module.exports = __webpack_public_path__ + "static/media/aboutSketch.3a809c79.svg";